<template>
  <bb-modal
    :visible="visible"
    flavor="card"
    public-size="m"
    class="align-center signing-modal"
    static-overlay
    @close="$emit('close')"
  >
    <bb-icon
      name="illustration-no-account"
      fill="original"
      size="auto"
      class="p-x-60"
      animated
    />
    <p class="color-gray-90 p-b-20 p-t-10">
      {{ verificationHeader }}
    </p>
    <bb-form
      :submit-text="$t('digitalAuthenticationMethods.submit')"
      :error-text="$t('digitalAuthenticationMethods.errorText')"
      :loading="loading"
      :enabled="loading"
      static-submit
      @submit="$emit('initiate-authentication')"
    >
      <bb-masked-input
        v-if="activeVerificationMethod === VerificationMethods.MOBILE_ID"
        id="mobilePhoneInput"
        v-model="currentMobileNumber"
        v-validate="'required|mobilePhone' + $selectedDomain()"
        framed
        type="tel"
        :mask="$maskedMobilePhone()"
        name="mobilePhone"
        :label="$t('digitalAuthenticationMethods.mobileNumber')"
        :data-vv-as="$t('digitalAuthenticationMethods.mobileNumber')"
      />
      <bb-input
        id="personalCodeInput"
        v-model="currentPersonalIdentityCode"
        v-validate="'required|personalCode' + $selectedDomain()"
        :label="$t('digitalAuthenticationMethods.personalIdentityCode')"
        :data-vv-as="$t('digitalAuthenticationMethods.personalIdentityCode')"
        name="personalIdentityCode"
      />
    </bb-form>
    <div v-if="$isEe() || $isLt()" class="color-blue p-t-20 f-smallest">
      <bb-icon
        name="ui-alert-circle-outline"
        size="18"
        fill="yellow"
      />
      {{ $t('digitalAuthenticationMethods.multipleAccountWarning') }}
    </div>
  </bb-modal>
</template>
<script>
  import { BbModal, BbIcon, BbForm, BbMaskedInput, BbInput } from '@bigbank/interface-components';
  import { VerificationMethods } from '@/types/common/enums';

  export default {
    name: 'authentication-modal',
    $_veeValidate: {
      validator: 'new',
    },
    components: {
      BbModal,
      BbIcon,
      BbForm,
      BbMaskedInput,
      BbInput,
    },
    props: {
      visible: Boolean,
      loading: Boolean,
      activeVerificationMethod: String,
      personalIdentityCode: String,
      mobileNumber: String,
    },
    data() {
      return {
        VerificationMethods,
      };
    },
    computed: {
      verificationHeader() {
        return this.activeVerificationMethod === VerificationMethods.MOBILE_ID
          ? this.$t('digitalAuthenticationMethods.mobileIdHeader')
          : this.$t('digitalAuthenticationMethods.smartIdHeader');
      },
      currentPersonalIdentityCode: {
        get() {
          return this.personalIdentityCode;
        },
        set(newVal) {
          this.$emit('update:personal-identity-code', newVal);
        },
      },
      currentMobileNumber: {
        get() {
          return this.mobileNumber;
        },
        set(newVal) {
          this.$emit('update:mobile-number', newVal);
        },
      },
    },
  };
</script>

<style>
.signing-modal .bb-modal__body {
  max-height: 65vh !important;
}
</style>
